function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var methodName = context.method, method = delegate.iterator[methodName]; if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel; var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) keys.push(key); return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, catch: function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { __awaiter } from "tslib";
import { Entity } from "../util/Entity";
import { Template } from "../util/Template";
import { Percent } from "../util/Percent";
import { EventDispatcher } from "../util/EventDispatcher";
import { MultiDisposer, CounterDisposer } from "../util/Disposer";
import { waitForAnimations } from "../util/Animation";
import * as $utils from "../util/Utils";
import * as $array from "../util/Array";
import * as $type from "../util/Type";
import * as $object from "../util/Object";
import * as $math from "../util/Math";
//import { populateString } from "../util/PopulateString";
/**
 * An [[EventDispatcher]] for [[Sprite]].
 *
 * @see {@link https://www.amcharts.com/docs/v5/concepts/events/} for more info
 */
var SpriteEventDispatcher = /*#__PURE__*/function (_EventDispatcher) {
  _inherits(SpriteEventDispatcher, _EventDispatcher);
  var _super = _createSuper(SpriteEventDispatcher);
  function SpriteEventDispatcher(sprite) {
    var _this;
    _classCallCheck(this, SpriteEventDispatcher);
    _this = _super.call(this);
    Object.defineProperty(_assertThisInitialized(_this), "_sprite", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this), "_rendererDisposers", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(_assertThisInitialized(_this), "_dispatchParents", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: true
    });
    _this._sprite = sprite;
    return _this;
  }
  _createClass(SpriteEventDispatcher, [{
    key: "_makePointerEvent",
    value: function _makePointerEvent(key, event) {
      return {
        type: key,
        originalEvent: event.event,
        point: event.point,
        simulated: event.simulated,
        native: event.native,
        target: this._sprite
      };
    }
  }, {
    key: "_onRenderer",
    value: function _onRenderer(key, dispatch) {
      var _this2 = this;
      // TODO: is this OK? it'd be good not to require to set this on each individual element
      this._sprite.set("interactive", true);
      this._sprite._display.interactive = true;
      var events = this._rendererDisposers[key];
      if (events === undefined) {
        var disposer = this._sprite._display.on(key, function (e) {
          dispatch.call(_this2, e);
        });
        events = this._rendererDisposers[key] = new CounterDisposer(function () {
          delete _this2._rendererDisposers[key];
          disposer.dispose();
        });
      }
      return events.increment();
    }
  }, {
    key: "_on",
    value: function _on(once, type, callback, context, shouldClone, dispatch) {
      var info = _get(_getPrototypeOf(SpriteEventDispatcher.prototype), "_on", this).call(this, once, type, callback, context, shouldClone, dispatch);
      var rendererEvent = SpriteEventDispatcher.RENDERER_EVENTS[type];
      if (rendererEvent !== undefined) {
        info.disposer = new MultiDisposer([info.disposer, this._onRenderer(type, rendererEvent)]);
      }
      return info;
    }
    /**
     * Will stop any bubbling up of the event to element's parents.
     *
     * Should be called in an event handler, e.g.:
     *
     * ```TypeScript
     * element.events.on("pointerdown", function(ev) {
     *   // Do something here and prevent from "pointerdown" bubbling up
     *   // ...
     *   ev.target.events.stopParentDispatch();
     * });
     * ```
     * ```JavaScript
     * element.events.on("pointerdown", function(ev) {
     *   // Do something here and prevent from "pointerdown" bubbling up
     *   // ...
     *   ev.target.events.stopParentDispatch();
     * });
     * ```
     */
  }, {
    key: "stopParentDispatch",
    value: function stopParentDispatch() {
      this._dispatchParents = false;
    }
    /**
     * @ignore
     */
  }, {
    key: "dispatchParents",
    value: function dispatchParents(type, event) {
      var old = this._dispatchParents;
      this._dispatchParents = true;
      try {
        this.dispatch(type, event);
        if (this._dispatchParents && this._sprite.parent) {
          this._sprite.parent.events.dispatchParents(type, event);
        }
      } finally {
        this._dispatchParents = old;
      }
    }
  }]);
  return SpriteEventDispatcher;
}(EventDispatcher);
Object.defineProperty(SpriteEventDispatcher, "RENDERER_EVENTS", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: {
    "click": function click(event) {
      if (this.isEnabled("click") && !this._sprite.isDragging() && this._sprite._hasDown() && !this._sprite._hasMoved(this._makePointerEvent("click", event))) {
        this.dispatch("click", this._makePointerEvent("click", event));
      }
    },
    "rightclick": function rightclick(event) {
      if (this.isEnabled("rightclick")) {
        this.dispatch("rightclick", this._makePointerEvent("rightclick", event));
      }
    },
    "middleclick": function middleclick(event) {
      if (this.isEnabled("middleclick")) {
        this.dispatch("middleclick", this._makePointerEvent("middleclick", event));
      }
    },
    "dblclick": function dblclick(event) {
      this.dispatchParents("dblclick", this._makePointerEvent("dblclick", event));
    },
    "pointerover": function pointerover(event) {
      if (this.isEnabled("pointerover")) {
        this.dispatch("pointerover", this._makePointerEvent("pointerover", event));
      }
    },
    "pointerout": function pointerout(event) {
      if (this.isEnabled("pointerout")) {
        this.dispatch("pointerout", this._makePointerEvent("pointerout", event));
      }
    },
    "pointerdown": function pointerdown(event) {
      this.dispatchParents("pointerdown", this._makePointerEvent("pointerdown", event));
    },
    "pointerup": function pointerup(event) {
      if (this.isEnabled("pointerup")) {
        this.dispatch("pointerup", this._makePointerEvent("pointerup", event));
      }
    },
    "globalpointerup": function globalpointerup(event) {
      if (this.isEnabled("globalpointerup")) {
        this.dispatch("globalpointerup", this._makePointerEvent("globalpointerup", event));
      }
    },
    "globalpointermove": function globalpointermove(event) {
      if (this.isEnabled("globalpointermove")) {
        this.dispatch("globalpointermove", this._makePointerEvent("globalpointermove", event));
      }
    },
    "wheel": function wheel(event) {
      this.dispatchParents("wheel", {
        type: "wheel",
        target: this._sprite,
        originalEvent: event.event,
        point: event.point
      });
    }
  }
});
/**
 * A base class for all visual elements.
 *
 * @important
 */
export var Sprite = /*#__PURE__*/function (_Entity) {
  _inherits(Sprite, _Entity);
  var _super2 = _createSuper(Sprite);
  function Sprite() {
    var _this3;
    _classCallCheck(this, Sprite);
    _this3 = _super2.apply(this, arguments);
    Object.defineProperty(_assertThisInitialized(_this3), "_adjustedLocalBounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_localBounds", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_parent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_dataItem", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_templateField", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_sizeDirty", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    // Will be true only when dragging
    Object.defineProperty(_assertThisInitialized(_this3), "_isDragging", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    // The event when the dragging starts
    Object.defineProperty(_assertThisInitialized(_this3), "_dragEvent", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    // The position when dragging starts
    Object.defineProperty(_assertThisInitialized(_this3), "_dragPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_isHidden", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_isShowing", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_isHiding", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_isDown", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_downPoint", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_downPoints", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: {}
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_toggleDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_dragDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_tooltipDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_hoverDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_focusDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_tooltipMoveDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_tooltipPointerDp", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: void 0
    });
    Object.defineProperty(_assertThisInitialized(_this3), "_statesHandled", {
      enumerable: true,
      configurable: true,
      writable: true,
      value: false
    });
    return _this3;
  }
  _createClass(Sprite, [{
    key: "_afterNew",
    value: function _afterNew() {
      this.setPrivateRaw("visible", true);
      _get(_getPrototypeOf(Sprite.prototype), "_afterNew", this).call(this);
    }
  }, {
    key: "_markDirtyKey",
    value: function _markDirtyKey(key) {
      _get(_getPrototypeOf(Sprite.prototype), "_markDirtyKey", this).call(this, key);
      if (key == "x" || key == "y" || key == "dx" || key == "dy") {
        this.markDirtyBounds();
        this._addPercentagePositionChildren();
        this.markDirtyPosition();
      }
    }
  }, {
    key: "_markDirtyPrivateKey",
    value: function _markDirtyPrivateKey(key) {
      _get(_getPrototypeOf(Sprite.prototype), "_markDirtyPrivateKey", this).call(this, key);
      if (key == "x" || key == "y") {
        this.markDirtyPosition();
      }
    }
  }, {
    key: "_removeTemplateField",
    value: function _removeTemplateField() {
      if (this._templateField) {
        this._templateField._removeObjectTemplate(this);
      }
    }
  }, {
    key: "_createEvents",
    value: function _createEvents() {
      return new SpriteEventDispatcher(this);
    }
  }, {
    key: "_processTemplateField",
    value: function _processTemplateField() {
      var template;
      var field = this.get("templateField");
      if (field) {
        var dataItem = this.dataItem;
        if (dataItem) {
          var context = dataItem.dataContext;
          if (context) {
            template = context[field];
            if (!(template instanceof Template) && template) {
              template = Template.new(template);
            }
          }
        }
      }
      if (this._templateField !== template) {
        this._removeTemplateField();
        this._templateField = template;
        if (template) {
          template._setObjectTemplate(this);
        }
        this._applyTemplates();
      }
    }
    // TODO change this to run before the element is added to the parent, so that way
    //      it doesn't need to apply the themes twice
  }, {
    key: "_setDataItem",
    value: function _setDataItem(dataItem) {
      var oldDataItem = this._dataItem;
      this._dataItem = dataItem;
      this._processTemplateField();
      var eventType = "dataitemchanged";
      if (dataItem != oldDataItem) {
        if (this.events.isEnabled(eventType)) {
          this.events.dispatch(eventType, {
            type: eventType,
            target: this,
            oldDataItem: oldDataItem,
            newDataItem: dataItem
          });
        }
      }
    }
    /**
     * A [[DataItem]] used for this element.
     *
     * NOTE: data item is being assigned automatically in most cases where it
     * matters. Use this accessor to set data item only if you know what you're
     * doing.
     *
     * @param  value  Data item
     */
  }, {
    key: "dataItem",
    get:
    /**
     * @return DataItem
     */
    function get() {
      if (this._dataItem) {
        return this._dataItem;
      } else {
        var parent = this._parent;
        while (parent) {
          if (parent._dataItem) {
            return parent._dataItem;
          } else {
            parent = parent._parent;
          }
        }
      }
    },
    set: function set(value) {
      this._setDataItem(value);
    }
  }, {
    key: "_addPercentageSizeChildren",
    value: function _addPercentageSizeChildren() {
      var parent = this.parent;
      if (parent) {
        if (this.get("width") instanceof Percent || this.get("height") instanceof Percent) {
          $array.pushOne(parent._percentageSizeChildren, this);
        } else {
          $array.removeFirst(parent._percentageSizeChildren, this);
        }
      }
    }
  }, {
    key: "_addPercentagePositionChildren",
    value: function _addPercentagePositionChildren() {
      var parent = this.parent;
      if (parent) {
        if (this.get("x") instanceof Percent || this.get("y") instanceof Percent) {
          $array.pushOne(parent._percentagePositionChildren, this);
        } else {
          $array.removeFirst(parent._percentagePositionChildren, this);
        }
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirtyPosition",
    value: function markDirtyPosition() {
      this._root._addDirtyPosition(this);
    }
  }, {
    key: "updatePivotPoint",
    value: function updatePivotPoint() {
      var bounds = this._localBounds;
      if (bounds) {
        var centerX = this.get("centerX");
        if (centerX != null) {
          this._display.pivot.x = bounds.left + $utils.relativeToValue(centerX, bounds.right - bounds.left);
        }
        var centerY = this.get("centerY");
        if (centerY != null) {
          this._display.pivot.y = bounds.top + $utils.relativeToValue(centerY, bounds.bottom - bounds.top);
        }
      }
    }
  }, {
    key: "_beforeChanged",
    value: function _beforeChanged() {
      var _this4 = this;
      _get(_getPrototypeOf(Sprite.prototype), "_beforeChanged", this).call(this);
      // handling states in beforeChanged, otherwise states is not applied without animated theme
      this._handleStates();
      if (this.isDirty("tooltip")) {
        var previous = this._prevSettings.tooltip;
        if (previous) {
          previous.dispose();
        }
      }
      if (this.isDirty("layer") || this.isDirty("layerMargin")) {
        this._display.setLayer(this.get("layer"), this.get("layerMargin"));
        this.markDirtyLayer();
      }
      if (this.isDirty("tooltipPosition")) {
        var tooltipMoveDp = this._tooltipMoveDp;
        if (tooltipMoveDp) {
          tooltipMoveDp.dispose();
          this._tooltipMoveDp = undefined;
        }
        var tooltipPointerDp = this._tooltipPointerDp;
        if (tooltipPointerDp) {
          tooltipPointerDp.dispose();
          this._tooltipPointerDp = undefined;
        }
        if (this.get("tooltipPosition") == "pointer") {
          this._tooltipPointerDp = new MultiDisposer([this.events.on("pointerover", function () {
            _this4._tooltipMoveDp = _this4.events.on("globalpointermove", function (e) {
              _this4.showTooltip(e.point);
            });
          }), this.events.on("pointerout", function () {
            var tooltipMoveDp = _this4._tooltipMoveDp;
            if (tooltipMoveDp) {
              tooltipMoveDp.dispose();
              _this4._tooltipMoveDp = undefined;
            }
          })]);
        }
      }
    }
  }, {
    key: "_handleStates",
    value: function _handleStates() {
      if (!this._statesHandled) {
        if (this.isDirty("active")) {
          if (this.get("active")) {
            this.states.applyAnimate("active");
            this.set("ariaChecked", true);
          } else {
            if (!this.isHidden()) {
              this.states.applyAnimate("default");
            }
            this.set("ariaChecked", false);
          }
          this.markDirtyAccessibility();
        }
        if (this.isDirty("disabled")) {
          if (this.get("disabled")) {
            this.states.applyAnimate("disabled");
            this.set("ariaChecked", false);
          } else {
            if (!this.isHidden()) {
              this.states.applyAnimate("default");
            }
            this.set("ariaChecked", true);
          }
          this.markDirtyAccessibility();
        }
        this._statesHandled = true;
      }
    }
  }, {
    key: "_changed",
    value: function _changed() {
      var _this5 = this;
      _get(_getPrototypeOf(Sprite.prototype), "_changed", this).call(this);
      var display = this._display;
      var events = this.events;
      if (this.isDirty("draggable")) {
        var draggable = this.get("draggable");
        if (draggable) {
          this.set("interactive", true);
          this._dragDp = new MultiDisposer([events.on("pointerdown", function (ev) {
            _this5.dragStart(ev);
          }), events.on("globalpointermove", function (ev) {
            _this5.dragMove(ev);
          }), events.on("globalpointerup", function (ev) {
            _this5.dragStop(ev);
          })]);
        } else {
          if (this._dragDp) {
            this._dragDp.dispose();
            this._dragDp = undefined;
          }
        }
        display.cancelTouch = draggable ? true : false;
      }
      if (this.isDirty("tooltipText") || this.isDirty("tooltipHTML") || this.isDirty("showTooltipOn")) {
        var tooltipText = this.get("tooltipText");
        var tooltipHTML = this.get("tooltipHTML");
        var showTooltipOn = this.get("showTooltipOn", "hover");
        if (this._tooltipDp) {
          this._tooltipDp.dispose();
          this._tooltipDp = undefined;
        }
        if (tooltipText || tooltipHTML) {
          if (showTooltipOn == "click") {
            this._tooltipDp = new MultiDisposer([events.on("click", function () {
              _this5.setTimeout(function () {
                return _this5.showTooltip();
              }, 10);
            }), $utils.addEventListener(document, "click", function (_ev) {
              _this5.hideTooltip();
            })]);
          } else if (showTooltipOn == "always") {
            // nothing
          } else {
            this._tooltipDp = new MultiDisposer([events.on("pointerover", function () {
              _this5.showTooltip();
            }), events.on("pointerout", function () {
              _this5.hideTooltip();
            })]);
          }
        }
      }
      if (this.isDirty("toggleKey")) {
        var toggleKey = this.get("toggleKey");
        if (toggleKey && toggleKey != "none") {
          this._toggleDp = events.on("click", function () {
            if (!_this5._isDragging) {
              _this5.set(toggleKey, !_this5.get(toggleKey));
            }
          });
        } else {
          if (this._toggleDp) {
            this._toggleDp.dispose();
            this._toggleDp = undefined;
          }
        }
      }
      if (this.isDirty("opacity")) {
        display.alpha = Math.max(0, this.get("opacity", 1));
      }
      if (this.isDirty("rotation")) {
        this.markDirtyBounds();
        display.angle = this.get("rotation", 0);
      }
      if (this.isDirty("scale")) {
        this.markDirtyBounds();
        display.scale = this.get("scale", 0);
      }
      if (this.isDirty("centerX") || this.isDirty("centerY")) {
        this.markDirtyBounds();
        this.updatePivotPoint();
      }
      if (this.isDirty("visible") || this.isPrivateDirty("visible") || this.isDirty("forceHidden")) {
        if (!this.get("visible") || !this.getPrivate("visible") || this.get("forceHidden")) {
          display.visible = false;
          this.hideTooltip();
        } else {
          display.visible = true;
        }
        this.markDirtyBounds();
        if (this.get("focusable")) {
          this.markDirtyAccessibility();
        }
      }
      if (this.isDirty("width") || this.isDirty("height")) {
        this.markDirtyBounds();
        this._addPercentageSizeChildren();
        var parent = this.parent;
        if (parent) {
          if (this.isDirty("width") && this.get("width") instanceof Percent || this.isDirty("height") && this.get("height") instanceof Percent) {
            parent.markDirty();
            parent._prevWidth = 0;
          }
        }
        this._sizeDirty = true;
      }
      if (this.isDirty("maxWidth") || this.isDirty("maxHeight") || this.isPrivateDirty("width") || this.isPrivateDirty("height") || this.isDirty("minWidth") || this.isDirty("minHeight") || this.isPrivateDirty("maxWidth") || this.isPrivateDirty("maxHeight") || this.isPrivateDirty("minWidth") || this.isPrivateDirty("minHeight")) {
        this.markDirtyBounds();
        this._sizeDirty = true;
      }
      if (this._sizeDirty) {
        this._updateSize();
      }
      if (this.isDirty("wheelable")) {
        var wheelable = this.get("wheelable");
        if (wheelable) {
          this.set("interactive", true);
        }
        display.wheelable = wheelable ? true : false;
      }
      // Accessibility
      if (this.isDirty("tabindexOrder") || this.isDirty("focusableGroup")) {
        if (this.get("focusable")) {
          this._root._registerTabindexOrder(this);
        } else {
          this._root._unregisterTabindexOrder(this);
        }
      }
      if (this.isDirty("filter")) {
        //this.markDirtyBounds();
        display.filter = this.get("filter");
      }
      if (this.isDirty("cursorOverStyle")) {
        display.cursorOverStyle = this.get("cursorOverStyle");
      }
      if (this.isDirty("hoverOnFocus")) {
        if (this.get("hoverOnFocus")) {
          this._focusDp = new MultiDisposer([events.on("focus", function () {
            // TODO: proper hover, not just tooltip
            _this5.showTooltip();
          }), events.on("blur", function () {
            // TODO: proper hover, not just tooltip
            _this5.hideTooltip();
          })]);
        } else {
          if (this._focusDp) {
            this._focusDp.dispose();
            this._focusDp = undefined;
          }
        }
      }
      if (this.isDirty("focusable")) {
        if (this.get("focusable")) {
          this._root._registerTabindexOrder(this);
        } else {
          this._root._unregisterTabindexOrder(this);
        }
        this.markDirtyAccessibility();
      }
      if (this.isDirty("role") || this.isDirty("ariaLive") || this.isDirty("ariaChecked") || this.isDirty("ariaHidden") || this.isDirty("ariaOrientation") || this.isDirty("ariaValueNow") || this.isDirty("ariaValueMin") || this.isDirty("ariaValueMax") || this.isDirty("ariaValueText") || this.isDirty("ariaLabel") || this.isDirty("ariaControls")) {
        // display.accessibility.ariaLabel = populateString(this, this.get("ariaLabel", ""));
        // @todo make sure ariaLabel gets populated in Root
        this.markDirtyAccessibility();
      }
      if (this.isDirty("exportable")) {
        display.exportable = this.get("exportable");
      }
      if (this.isDirty("interactive")) {
        var _events = this.events;
        if (this.get("interactive")) {
          this._hoverDp = new MultiDisposer([_events.on("click", function (ev) {
            if ($utils.isTouchEvent(ev.originalEvent)) {
              if (!_this5.getPrivate("touchHovering")) {
                _this5.setTimeout(function () {
                  _this5._handleOver();
                  if (_this5.get("tooltipText") || _this5.get("tooltipHTML")) {
                    _this5.showTooltip();
                  }
                  _this5.setPrivateRaw("touchHovering", true);
                  _this5.events.dispatch("pointerover", {
                    type: "pointerover",
                    target: ev.target,
                    originalEvent: ev.originalEvent,
                    point: ev.point,
                    simulated: ev.simulated
                  });
                }, 10);
              }
            }
          }), _events.on("globalpointerup", function (ev) {
            if ($utils.isTouchEvent(ev.originalEvent)) {
              if (_this5.getPrivate("touchHovering")) {
                _this5._handleOut();
                if (_this5.get("tooltipText") || _this5.get("tooltipHTML")) {
                  _this5.hideTooltip();
                }
              }
              _this5.setPrivateRaw("touchHovering", false);
              _this5.events.dispatch("pointerout", {
                type: "pointerout",
                target: ev.target,
                originalEvent: ev.originalEvent,
                point: ev.point,
                simulated: ev.simulated
              });
            }
            if (_this5._isDown) {
              _this5._handleUp(ev);
            }
            //this._isDown = false;
          }), _events.on("pointerover", function () {
            _this5._handleOver();
          }), _events.on("pointerout", function () {
            _this5._handleOut();
          }), _events.on("pointerdown", function (e) {
            _this5._handleDown(e);
          })]);
        } else {
          this._display.interactive = false;
          if (this._hoverDp) {
            this._hoverDp.dispose();
            this._hoverDp = undefined;
          }
        }
      }
      if (this.isDirty("forceInactive")) {
        this._display.inactive = this.get("forceInactive", false);
      }
      if (this.get("showTooltipOn") == "always" && this._display.visible) {
        this.showTooltip();
      }
    }
    /**
     * @ignore
     * @todo should this be user-accessible?
     */
  }, {
    key: "dragStart",
    value: function dragStart(e) {
      this._dragEvent = e;
      this.events.stopParentDispatch();
    }
    /**
     * @ignore
     * @todo should this be user-accessible?
     */
  }, {
    key: "dragStop",
    value: function dragStop(e) {
      this._dragEvent = undefined;
      this._dragPoint = undefined;
      this.events.stopParentDispatch();
      if (this._isDragging) {
        this._isDragging = false;
        var type = "dragstop";
        if (this.events.isEnabled(type)) {
          this.events.dispatch(type, {
            type: type,
            target: this,
            originalEvent: e.originalEvent,
            point: e.point,
            simulated: e.simulated
          });
        }
      }
    }
  }, {
    key: "_handleOver",
    value: function _handleOver() {
      if (!this.isHidden()) {
        if (this.get("active") && this.states.lookup("hoverActive")) {
          this.states.applyAnimate("hoverActive");
        } else if (this.get("disabled") && this.states.lookup("hoverDisabled")) {
          this.states.applyAnimate("hoverDisabled");
        } else {
          this.states.applyAnimate("hover");
        }
        if (this.get("draggable") && this._isDown && this.states.lookup("down")) {
          this.states.applyAnimate("down");
        }
      }
    }
  }, {
    key: "_handleOut",
    value: function _handleOut() {
      if (!this.isHidden()) {
        if (this.get("active") && this.states.lookup("active")) {
          this.states.applyAnimate("active");
        } else if (this.get("disabled") && this.states.lookup("disabled")) {
          this.states.applyAnimate("disabled");
        } else {
          if (this.states.lookup("hover") || this.states.lookup("hoverActive")) {
            this.states.applyAnimate("default");
          }
        }
        if (this.get("draggable") && this._isDown && this.states.lookup("down")) {
          this.states.applyAnimate("down");
        }
      }
    }
  }, {
    key: "_handleUp",
    value: function _handleUp(e) {
      if (!this.isHidden()) {
        if (this.get("active") && this.states.lookup("active")) {
          this.states.applyAnimate("active");
        } else if (this.get("disabled") && this.states.lookup("disabled")) {
          this.states.applyAnimate("disabled");
        } else if (this.states.lookup("down")) {
          if (this.isHover()) {
            this.states.applyAnimate("hover");
          } else {
            this.states.applyAnimate("default");
          }
        }
        // @todo remove this once migrated to _downPoints
        this._downPoint = undefined;
        var pointerId = $utils.getPointerId(e.originalEvent);
        delete this._downPoints[pointerId];
        if ($object.keys(this._downPoints).length == 0) {
          this._isDown = false;
        }
      }
    }
  }, {
    key: "_hasMoved",
    value: function _hasMoved(e) {
      // @todo remove this once migrated to _downPoints
      // if (this._downPoint) {
      // 	const x = Math.abs(this._downPoint.x - e.point.x);
      // 	const y = Math.abs(this._downPoint.y - e.point.y);
      // 	return (x > 5) || (y > 5);
      // }
      var pointerId = $utils.getPointerId(e.originalEvent);
      var downPoint = this._downPoints[pointerId];
      if (downPoint) {
        var x = Math.abs(downPoint.x - e.point.x);
        var y = Math.abs(downPoint.y - e.point.y);
        return x > 5 || y > 5;
      }
      return false;
    }
  }, {
    key: "_hasDown",
    value: function _hasDown() {
      return $object.keys(this._downPoints).length > 0;
    }
  }, {
    key: "_handleDown",
    value: function _handleDown(e) {
      var parent = this.parent;
      if (parent && !this.get("draggable")) {
        parent._handleDown(e);
      }
      if (this.get("interactive") && !this.isHidden()) {
        if (this.states.lookup("down")) {
          this.states.applyAnimate("down");
        }
        this._downPoint = {
          x: e.point.x,
          y: e.point.y
        };
        // @todo remove this once migrated to _downPoints
        this._isDown = true;
        var pointerId = $utils.getPointerId(e.originalEvent);
        this._downPoints[pointerId] = {
          x: e.point.x,
          y: e.point.y
        };
      }
    }
    /**
     * @ignore
     * @todo should this be user-accessible?
     */
  }, {
    key: "dragMove",
    value: function dragMove(e) {
      var dragEvent = this._dragEvent;
      if (dragEvent) {
        if (dragEvent.simulated && !e.simulated) {
          return true;
        }
        var angle = 0;
        var parent = this.parent;
        while (parent != null) {
          angle += parent.get("rotation", 0);
          parent = parent.parent;
        }
        var x = e.point.x - dragEvent.point.x;
        var y = e.point.y - dragEvent.point.y;
        var events = this.events;
        if (dragEvent.simulated && !this._isDragging) {
          this._isDragging = true;
          this._dragEvent = e;
          this._dragPoint = {
            x: this.x(),
            y: this.y()
          };
          var type = "dragstart";
          if (events.isEnabled(type)) {
            events.dispatch(type, {
              type: type,
              target: this,
              originalEvent: e.originalEvent,
              point: e.point,
              simulated: e.simulated
            });
          }
        }
        if (this._isDragging) {
          var dragPoint = this._dragPoint;
          this.set("x", dragPoint.x + x * $math.cos(angle) + y * $math.sin(angle));
          this.set("y", dragPoint.y + y * $math.cos(angle) - x * $math.sin(angle));
          var _type = "dragged";
          if (events.isEnabled(_type)) {
            events.dispatch(_type, {
              type: _type,
              target: this,
              originalEvent: e.originalEvent,
              point: e.point,
              simulated: e.simulated
            });
          }
        } else {
          if (Math.hypot(x, y) > 5) {
            this._isDragging = true;
            this._dragEvent = e;
            this._dragPoint = {
              x: this.x(),
              y: this.y()
            };
            var _type2 = "dragstart";
            if (events.isEnabled(_type2)) {
              events.dispatch(_type2, {
                type: _type2,
                target: this,
                originalEvent: e.originalEvent,
                point: e.point,
                simulated: e.simulated
              });
            }
          }
        }
      }
    }
  }, {
    key: "_updateSize",
    value: function _updateSize() {}
  }, {
    key: "_getBounds",
    value: function _getBounds() {
      this._localBounds = this._display.getLocalBounds();
    }
    /**
     * Returns depth (how deep in the hierachy of the content tree) of this
     * element.
     *
     * @return Depth
     */
  }, {
    key: "depth",
    value: function depth() {
      var self = this.parent;
      var depth = 0;
      while (true) {
        if (self) {
          ++depth;
          self = self.parent;
        } else {
          return depth;
        }
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirtySize",
    value: function markDirtySize() {
      this._sizeDirty = true;
      this.markDirty();
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirtyBounds",
    value: function markDirtyBounds() {
      var display = this._display;
      if (this.get("isMeasured")) {
        this._root._addDirtyBounds(this);
        display.isMeasured = true;
        display.invalidateBounds();
        var parent = this.parent;
        if (parent && this.get("position") != "absolute") {
          if (parent.get("width") == null || parent.get("height") == null || parent.get("layout")) {
            parent.markDirtyBounds();
          }
        }
        if (this.get("focusable") && this.isFocus()) {
          this.markDirtyAccessibility();
        }
      }
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirtyAccessibility",
    value: function markDirtyAccessibility() {
      //if (this._root.focused(this)) {
      this._root._invalidateAccessibility(this);
      //}
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirtyLayer",
    value: function markDirtyLayer() {
      //this._display.markDirtyLayer(this.isDirty("opacity") || this.isDirty("visible")); https://codepen.io/team/amcharts/pen/gOWZPmP <- problems
      this._display.markDirtyLayer(true);
    }
    /**
     * @ignore
     */
  }, {
    key: "markDirty",
    value: function markDirty() {
      _get(_getPrototypeOf(Sprite.prototype), "markDirty", this).call(this);
      this.markDirtyLayer();
    }
  }, {
    key: "_updateBounds",
    value: function _updateBounds() {
      var oldBounds = this._adjustedLocalBounds;
      var newBounds;
      // if display.visible == false, it still returns bounds
      if (!this.get("visible") || !this.getPrivate("visible") || this.get("forceHidden")) {
        newBounds = {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0
        };
        this._localBounds = newBounds;
        this._adjustedLocalBounds = newBounds;
      } else {
        this._getBounds();
        this._fixMinBounds(this._localBounds);
        this.updatePivotPoint();
        this._adjustedLocalBounds = this._display.getAdjustedBounds(this._localBounds);
        newBounds = this._adjustedLocalBounds;
      }
      if (!oldBounds || oldBounds.left !== newBounds.left || oldBounds.top !== newBounds.top || oldBounds.right !== newBounds.right || oldBounds.bottom !== newBounds.bottom) {
        var eventType = "boundschanged";
        if (this.events.isEnabled(eventType)) {
          this.events.dispatch(eventType, {
            type: eventType,
            target: this
          });
        }
        if (this.parent) {
          this.parent.markDirty();
          this.parent.markDirtyBounds();
        }
      }
    }
  }, {
    key: "_fixMinBounds",
    value: function _fixMinBounds(bounds) {
      var minWidth = this.get("minWidth", this.getPrivate("minWidth"));
      var minHeight = this.get("minHeight", this.getPrivate("minHeight"));
      if ($type.isNumber(minWidth)) {
        if (bounds.right - bounds.left < minWidth) {
          bounds.right = bounds.left + minWidth;
        }
      }
      if ($type.isNumber(minHeight)) {
        if (bounds.bottom - bounds.top < minHeight) {
          bounds.bottom = bounds.top + minHeight;
        }
      }
      var privateWidth = this.getPrivate("width");
      var privateHeight = this.getPrivate("height");
      if ($type.isNumber(privateWidth)) {
        bounds.right = bounds.left + privateWidth;
      }
      if ($type.isNumber(privateHeight)) {
        bounds.bottom = bounds.top + privateHeight;
      }
    }
  }, {
    key: "_removeParent",
    value: function _removeParent(parent) {
      if (parent) {
        parent.children.removeValue(this);
        $array.removeFirst(parent._percentageSizeChildren, this);
        $array.removeFirst(parent._percentagePositionChildren, this);
      }
    }
  }, {
    key: "_clearDirty",
    value: function _clearDirty() {
      _get(_getPrototypeOf(Sprite.prototype), "_clearDirty", this).call(this);
      this._sizeDirty = false;
      this._statesHandled = false;
    }
    /**
     * Simulate hover over element.
     */
  }, {
    key: "hover",
    value: function hover() {
      this.showTooltip();
      this._handleOver();
    }
    /**
     * Simulate unhover over element.
     */
  }, {
    key: "unhover",
    value: function unhover() {
      this.hideTooltip();
      this._handleOut();
    }
    /**
     * Shows element's [[Tooltip]].
     */
  }, {
    key: "showTooltip",
    value: function showTooltip(point) {
      var tooltip = this.getTooltip();
      var tooltipText = this.get("tooltipText");
      var tooltipHTML = this.get("tooltipHTML");
      if ((tooltipText || tooltipHTML) && tooltip) {
        var tooltipPosition = this.get("tooltipPosition");
        var tooltipTarget = this.getPrivate("tooltipTarget", this);
        if (tooltipPosition == "fixed" || !point) {
          this._display._setMatrix();
          point = this.toGlobal(tooltipTarget._getTooltipPoint());
        }
        tooltip.set("pointTo", point);
        tooltip.set("tooltipTarget", tooltipTarget);
        if (!tooltip.get("x")) {
          tooltip.set("x", point.x);
        }
        if (!tooltip.get("y")) {
          tooltip.set("y", point.y);
        }
        if (tooltipText) {
          tooltip.label.set("text", tooltipText);
        }
        if (tooltipHTML) {
          tooltip.label.set("html", tooltipHTML);
        }
        var dataItem = this.dataItem;
        if (dataItem) {
          tooltip.label._setDataItem(dataItem);
        }
        if (this.get("showTooltipOn") == "always" && (point.x < 0 || point.x > this._root.width() || point.y < 0 || point.y > this._root.height())) {
          this.hideTooltip();
          return;
        }
        tooltip.label.text.markDirtyText();
        var promise = tooltip.show();
        this.setPrivateRaw("showingTooltip", true);
        return promise;
      }
    }
    /**
     * Hides element's [[Tooltip]].
     */
  }, {
    key: "hideTooltip",
    value: function hideTooltip() {
      var tooltip = this.getTooltip();
      if (tooltip) {
        if (tooltip.get("tooltipTarget") == this.getPrivate("tooltipTarget", this)) {
          var timeout = tooltip.get("keepTargetHover") && tooltip.get("stateAnimationDuration", 0) == 0 ? 400 : undefined;
          var promise = tooltip.hide(timeout);
          this.setPrivateRaw("showingTooltip", false);
          return promise;
        }
      }
    }
  }, {
    key: "_getTooltipPoint",
    value: function _getTooltipPoint() {
      var bounds = this._localBounds;
      if (bounds) {
        var x = 0;
        var y = 0;
        if (!this.get("isMeasured")) {
          x = $utils.relativeToValue(this.get("tooltipX", 0), this.width());
          y = $utils.relativeToValue(this.get("tooltipY", 0), this.height());
        } else {
          x = bounds.left + $utils.relativeToValue(this.get("tooltipX", 0), bounds.right - bounds.left);
          y = bounds.top + $utils.relativeToValue(this.get("tooltipY", 0), bounds.bottom - bounds.top);
        }
        return {
          x: x,
          y: y
        };
      }
      return {
        x: 0,
        y: 0
      };
    }
    /**
     * Returns [[Tooltip]] used for this element.
     *
     * @return Tooltip
     */
  }, {
    key: "getTooltip",
    value: function getTooltip() {
      var tooltip = this.get("tooltip");
      if (!tooltip) {
        var parent = this.parent;
        if (parent) {
          return parent.getTooltip();
        }
      } else {
        return tooltip;
      }
    }
  }, {
    key: "_updatePosition",
    value: function _updatePosition() {
      var parent = this.parent;
      var dx = this.get("dx", 0);
      var dy = this.get("dy", 0);
      var x = this.get("x");
      var _x = this.getPrivate("x");
      var xx = 0;
      var yy = 0;
      var position = this.get("position");
      if (x instanceof Percent) {
        if (parent) {
          x = parent.innerWidth() * x.value + parent.get("paddingLeft", 0);
        } else {
          x = 0;
        }
      }
      if ($type.isNumber(x)) {
        xx = x + dx;
      } else {
        if (_x != null) {
          xx = _x;
        } else if (parent) {
          if (position == "relative") {
            xx = parent.get("paddingLeft", 0) + dx;
          }
        }
      }
      var y = this.get("y");
      var _y = this.getPrivate("y");
      if (y instanceof Percent) {
        if (parent) {
          y = parent.innerHeight() * y.value + parent.get("paddingTop", 0);
        } else {
          y = 0;
        }
      }
      if ($type.isNumber(y)) {
        yy = y + dy;
      } else {
        if (_y != null) {
          yy = _y;
        } else if (parent) {
          if (position == "relative") {
            yy = parent.get("paddingTop", 0) + dy;
          }
        }
      }
      var display = this._display;
      if (display.x != xx || display.y != yy) {
        display.invalidateBounds();
        display.x = xx;
        display.y = yy;
        var eventType = "positionchanged";
        if (this.events.isEnabled(eventType)) {
          this.events.dispatch(eventType, {
            type: eventType,
            target: this
          });
        }
      }
      // Update tooltip position together with the Sprite
      if (this.getPrivate("showingTooltip")) {
        this.showTooltip();
      }
    }
    /**
     * Returns element's actual X position in pixels.
     *
     * @return X (px)
     */
  }, {
    key: "x",
    value: function x() {
      var x = this.get("x");
      var _x = this.getPrivate("x");
      var parent = this.parent;
      if (parent) {
        if (x instanceof Percent) {
          return $utils.relativeToValue(x, parent.innerWidth()) + parent.get("paddingLeft", 0);
        } else {
          if (!$type.isNumber(x)) {
            if (_x != null) {
              return _x;
            } else {
              return parent.get("paddingLeft", this._display.x);
            }
          } else {
            return x;
          }
        }
      }
      return this._display.x;
    }
    /**
     * Returns element's actual Y position in pixels.
     *
     * @return Y (px)
     */
  }, {
    key: "y",
    value: function y() {
      var _y = this.getPrivate("y");
      if (_y != null) {
        return _y;
      }
      var y = this.get("y");
      var parent = this.parent;
      if (parent) {
        if (y instanceof Percent) {
          return $utils.relativeToValue(y, parent.innerHeight()) + parent.get("paddingTop", 0);
        } else {
          if (!$type.isNumber(y)) {
            if (_y != null) {
              return _y;
            } else {
              return parent.get("paddingTop", this._display.y);
            }
          } else {
            return y;
          }
        }
      }
      return this._display.y;
    }
  }, {
    key: "_dispose",
    value: function _dispose() {
      _get(_getPrototypeOf(Sprite.prototype), "_dispose", this).call(this);
      this._display.dispose();
      this._removeTemplateField();
      this._removeParent(this.parent);
      this._root._removeFocusElement(this);
      var tooltip = this.get("tooltip");
      if (tooltip) {
        tooltip.dispose();
      }
      this.markDirty();
    }
    /**
     * @ignore
     */
  }, {
    key: "adjustedLocalBounds",
    value: function adjustedLocalBounds() {
      this._fixMinBounds(this._adjustedLocalBounds);
      return this._adjustedLocalBounds;
    }
    /**
     * Returns local coordinates of the element's bounds.
     *
     * @ignore
     * @return Global bounds
     */
  }, {
    key: "localBounds",
    value: function localBounds() {
      return this._localBounds;
    }
    /**
     * Returns adjusted local coordinates of the element's bounds.
     *
     * @ignore
     * @return Global bounds
     */
  }, {
    key: "bounds",
    value: function bounds() {
      var bounds = this._adjustedLocalBounds;
      var x = this.x();
      var y = this.y();
      return {
        left: bounds.left + x,
        right: bounds.right + x,
        top: bounds.top + y,
        bottom: bounds.bottom + y
      };
    }
    /**
     * Returns global coordinates of the element's bounds.
     *
     * @ignore
     * @return Global bounds
     */
  }, {
    key: "globalBounds",
    value: function globalBounds() {
      var bounds = this.localBounds();
      var p0 = this.toGlobal({
        x: bounds.left,
        y: bounds.top
      });
      var p1 = this.toGlobal({
        x: bounds.right,
        y: bounds.top
      });
      var p2 = this.toGlobal({
        x: bounds.right,
        y: bounds.bottom
      });
      var p3 = this.toGlobal({
        x: bounds.left,
        y: bounds.bottom
      });
      return {
        left: Math.min(p0.x, p1.x, p2.x, p3.x),
        top: Math.min(p0.y, p1.y, p2.y, p3.y),
        right: Math.max(p0.x, p1.x, p2.x, p3.x),
        bottom: Math.max(p0.y, p1.y, p2.y, p3.y)
      };
    }
  }, {
    key: "_onShow",
    value: function _onShow(_duration) {}
  }, {
    key: "_onHide",
    value: function _onHide(_duration) {}
    /**
     * Plays initial reveal animation regardless if element is currently hidden
     * or visible.
     *
     * @param   duration  Duration of the animation in milliseconds
     * @param   delay     Delay showing of the element by X milliseconds
     * @return            Promise
     */
  }, {
    key: "appear",
    value: function appear(duration, delay) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var _this6 = this;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return this.hide(0);
            case 2:
              if (!delay) {
                _context.next = 6;
                break;
              }
              return _context.abrupt("return", new Promise(function (success, _error) {
                _this6.setTimeout(function () {
                  success(_this6.show(duration));
                }, delay);
              }));
            case 6:
              return _context.abrupt("return", this.show(duration));
            case 7:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
    }
    /**
     * Shows currently hidden element and returns a `Promise` which completes
     * when all showing animations are finished.
     *
     * ```TypeScript
     * series.show().then(function(ev) {
     *   console.log("Series is now fully visible");
     * })
     * ```
     * ```JavaScript
     * series.show().then(function(ev) {
     *   console.log("Series is now fully visible");
     * })
     * ```
     *
     * @return Promise
     */
  }, {
    key: "show",
    value: function show(duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var animations;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if (this._isShowing) {
                _context2.next = 10;
                break;
              }
              this._isHidden = false;
              this._isShowing = true;
              this._isHiding = false;
              if (this.states.lookup("default").get("visible")) {
                this.set("visible", true);
              }
              this._onShow(duration);
              animations = this.states.applyAnimate("default", duration);
              _context2.next = 9;
              return waitForAnimations(animations);
            case 9:
              this._isShowing = false;
            case 10:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this);
      }));
    }
    /**
     * Hides the element and returns a `Promise` which completes when all hiding
     * animations are finished.
     *
     * ```TypeScript
     * series.hide().then(function(ev) {
     *   console.log("Series finished hiding");
     * })
     * ```
     * ```JavaScript
     * series.hide().then(function(ev) {
     *   console.log("Series finished hiding");
     * })
     * ```
     *
     * @return Promise
     */
  }, {
    key: "hide",
    value: function hide(duration) {
      return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var state, animations;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!(!this._isHiding && !this._isHidden)) {
                _context3.next = 11;
                break;
              }
              this._isHiding = true;
              this._isShowing = false;
              state = this.states.lookup("hidden");
              if (!state) {
                state = this.states.create("hidden", {
                  "opacity": 0,
                  "visible": false
                });
              }
              this._isHidden = true;
              this._onHide(duration);
              animations = this.states.applyAnimate("hidden", duration);
              _context3.next = 10;
              return waitForAnimations(animations);
            case 10:
              this._isHiding = false;
            case 11:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
    }
    /**
     * Returns `true` if this element is currently hidden.
     *
     * @return Is hidden?
     */
  }, {
    key: "isHidden",
    value: function isHidden() {
      return this._isHidden;
    }
    /**
     * Returns `true` if this element is currently animating to a default state.
     *
     * @return Is showing?
     */
  }, {
    key: "isShowing",
    value: function isShowing() {
      return this._isShowing;
    }
    /**
     * Returns `true` if this element is currently animating to a hidden state.
     *
     * @return Is hiding?
     */
  }, {
    key: "isHiding",
    value: function isHiding() {
      return this._isHiding;
    }
    /**
     * Returns `true` if this element is currently hovered by a pointer.
     *
     * @return Is hovered?
     */
  }, {
    key: "isHover",
    value: function isHover() {
      return this._display.hovering();
    }
    /**
     * Returns `true` if this element does currently have focus.
     *
     * @return Is focused?
     */
  }, {
    key: "isFocus",
    value: function isFocus() {
      return this._root.focused(this);
    }
    /**
     * Returns `true` if this element is currently being dragged.
     *
     * @return Is dragged?
     */
  }, {
    key: "isDragging",
    value: function isDragging() {
      return this._isDragging;
    }
    /**
     * Returns `false` if if either public or private setting `visible` is set
     * to `false`, or `forceHidden` is set to `true`.
     *
     * @return Visible?
     */
  }, {
    key: "isVisible",
    value: function isVisible() {
      if (this.get("visible") && this.getPrivate("visible") && !this.get("forceHidden")) {
        return true;
      }
      return false;
    }
    /**
     * Same as `isVisible()`, except it checks all ascendants, too.
     *
     * @since 5.2.7
     * @return Visible?
     */
  }, {
    key: "isVisibleDeep",
    value: function isVisibleDeep() {
      return this._parent ? this._parent.isVisibleDeep() && this.isVisible() : this.isVisible();
    }
    /**
     * Returns an actual opacity of the element, taking into account all parents.
     *
     * @return Opacity
     * @since 5.2.11
     */
  }, {
    key: "compositeOpacity",
    value: function compositeOpacity() {
      var opacity = this.get("opacity", 1);
      return this._parent ? this._parent.compositeOpacity() * opacity : opacity;
    }
    /**
     * Returns width of this element in pixels.
     *
     * @return Width (px)
     */
  }, {
    key: "width",
    value: function width() {
      var width = this.get("width");
      var maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
      var minWidth = this.get("minWidth", this.getPrivate("minWidth"));
      var privateWidth = this.getPrivate("width");
      var w = 0;
      if ($type.isNumber(privateWidth)) {
        w = privateWidth;
      } else {
        if (width == null) {
          if (this._adjustedLocalBounds) {
            w = this._adjustedLocalBounds.right - this._adjustedLocalBounds.left;
          }
        } else {
          if (width instanceof Percent) {
            var parent = this.parent;
            if (parent) {
              w = parent.innerWidth() * width.value;
            } else {
              w = this._root.width() * width.value;
            }
          } else if ($type.isNumber(width)) {
            w = width;
          }
        }
      }
      if ($type.isNumber(minWidth)) {
        w = Math.max(minWidth, w);
      }
      if ($type.isNumber(maxWidth)) {
        w = Math.min(maxWidth, w);
      }
      return w;
    }
    /**
     * Returns maximum allowed width of this element in pixels.
     *
     * @return Maximum width (px)
     */
  }, {
    key: "maxWidth",
    value: function maxWidth() {
      var maxWidth = this.get("maxWidth", this.getPrivate("maxWidth"));
      if ($type.isNumber(maxWidth)) {
        return maxWidth;
      } else {
        var width = this.get("width");
        if ($type.isNumber(width)) {
          return width;
        }
      }
      var parent = this.parent;
      if (parent) {
        return parent.innerWidth();
      }
      return this._root.width();
    }
    /**
     * Returns maximum allowed height of this element in pixels.
     *
     * @return Maximum height (px)
     */
  }, {
    key: "maxHeight",
    value: function maxHeight() {
      var maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
      if ($type.isNumber(maxHeight)) {
        return maxHeight;
      } else {
        var height = this.get("height");
        if ($type.isNumber(height)) {
          return height;
        }
      }
      var parent = this.parent;
      if (parent) {
        return parent.innerHeight();
      }
      return this._root.height();
    }
    /**
     * Returns height of this element in pixels.
     *
     * @return Height (px)
     */
  }, {
    key: "height",
    value: function height() {
      var height = this.get("height");
      var maxHeight = this.get("maxHeight", this.getPrivate("maxHeight"));
      var minHeight = this.get("minHeight", this.getPrivate("minHeight"));
      var privateHeight = this.getPrivate("height");
      var h = 0;
      if ($type.isNumber(privateHeight)) {
        h = privateHeight;
      } else {
        if (height == null) {
          if (this._adjustedLocalBounds) {
            h = this._adjustedLocalBounds.bottom - this._adjustedLocalBounds.top;
          }
        } else {
          if (height instanceof Percent) {
            var parent = this.parent;
            if (parent) {
              h = parent.innerHeight() * height.value;
            } else {
              h = this._root.height() * height.value;
            }
          } else if ($type.isNumber(height)) {
            h = height;
          }
        }
      }
      if ($type.isNumber(minHeight)) {
        h = Math.max(minHeight, h);
      }
      if ($type.isNumber(maxHeight)) {
        h = Math.min(maxHeight, h);
      }
      return h;
    }
  }, {
    key: "_findStaticTemplate",
    value: function _findStaticTemplate(f) {
      // templateField overrides template
      if (this._templateField && f(this._templateField)) {
        return this._templateField;
      }
      return _get(_getPrototypeOf(Sprite.prototype), "_findStaticTemplate", this).call(this, f);
    }
  }, {
    key: "_walkParents",
    value: function _walkParents(f) {
      if (this._parent) {
        this._walkParent(f);
      }
    }
  }, {
    key: "_walkParent",
    value: function _walkParent(f) {
      if (this._parent) {
        this._parent._walkParent(f);
      }
      f(this);
    }
    /**
     * Parent [[Container]] of this element.
     *
     * @return Parent container
     */
  }, {
    key: "parent",
    get: function get() {
      return this._parent;
    }
  }, {
    key: "_setParent",
    value: function _setParent(parent) {
      var updateChildren = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var prevParent = this._parent;
      if (parent !== prevParent) {
        this.markDirtyBounds();
        parent.markDirty();
        this._parent = parent;
        if (updateChildren) {
          this._removeParent(prevParent);
          if (parent) {
            this._addPercentageSizeChildren();
            this._addPercentagePositionChildren();
          }
        }
        this.markDirtyPosition();
        this._applyThemes();
      }
    }
    /**
     * Returns an instance of [[NumberFormatter]] used in this element.
     *
     * If this element does not have it set, global one form [[Root]] is used.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
     * @return NumberFormatter instace
     */
  }, {
    key: "getNumberFormatter",
    value: function getNumberFormatter() {
      return this.get("numberFormatter", this._root.numberFormatter);
    }
    /**
     * Returns an instance of [[DateFormatter]] used in this element.
     *
     * If this element does not have it set, global one form [[Root]] is used.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
     * @return DateFormatter instace
     */
  }, {
    key: "getDateFormatter",
    value: function getDateFormatter() {
      return this.get("dateFormatter", this._root.dateFormatter);
    }
    /**
     * Returns an instance of [[DurationFormatter]] used in this element.
     *
     * If this element does not have it set, global one form [[Root]] is used.
     *
     * @see {@link https://www.amcharts.com/docs/v5/concepts/using-formatters/} for more info
     * @return DurationFormatter instace
     */
  }, {
    key: "getDurationFormatter",
    value: function getDurationFormatter() {
      return this.get("durationFormatter", this._root.durationFormatter);
    }
    /**
     * Converts X/Y coordinate within this element to a global coordinate.
     *
     * @param  point  Local coordinate
     * @return        Global coordinate
     */
  }, {
    key: "toGlobal",
    value: function toGlobal(point) {
      return this._display.toGlobal(point);
    }
    /**
     * Converts global X/Y coordinate to a coordinate within this element.
     *
     * @param  point  Global coordinate
     * @return        Local coordinate
     */
  }, {
    key: "toLocal",
    value: function toLocal(point) {
      return this._display.toLocal(point);
    }
  }, {
    key: "_getDownPoint",
    value: function _getDownPoint() {
      var id = this._getDownPointId();
      if (id) {
        return this._downPoints[id];
      }
    }
  }, {
    key: "_getDownPointId",
    value: function _getDownPointId() {
      if (this._downPoints) {
        return $object.keysOrdered(this._downPoints, function (a, b) {
          if (a > b) {
            return 1;
          }
          if (a < b) {
            return -1;
          }
          return 0;
        })[0];
      }
    }
    /**
     * Moves sprite to the end of the parent's children array.
     *
     * Depending on `layout` setting of the parten container, it may effect the
     * positioning or overlapping order of the elements.
     */
  }, {
    key: "toFront",
    value: function toFront() {
      var parent = this.parent;
      if (parent) {
        parent.children.moveValue(this, parent.children.length - 1);
      }
    }
    /**
     * Moves sprite to the beginning of the parent's children array.
     *
     * Depending on `layout` setting of the parten container, it may effect the
     * positioning or overlapping order of the elements.
     */
  }, {
    key: "toBack",
    value: function toBack() {
      var parent = this.parent;
      if (parent) {
        parent.children.moveValue(this, 0);
      }
    }
  }]);
  return Sprite;
}(Entity);
Object.defineProperty(Sprite, "className", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: "Sprite"
});
Object.defineProperty(Sprite, "classNames", {
  enumerable: true,
  configurable: true,
  writable: true,
  value: Entity.classNames.concat([Sprite.className])
});